import { Button } from 'flowbite-react';
import { Img } from 'react-image';

const NoApplicationsContainer = () => {

	return (
		<div className="mt-16 font-inter">
			<div className="flex justify-center">
				<Img
					loading="lazy"
					src="/assets/noApplicationsEmptyState.svg"
					alt="noApplicationsEmptyState"
					width="200"
					height="200"
				/>
			</div>
			<div className="mt-4 text-center text-2xl font-medium dark:text-[#FAFAFC] text-black">No applications yet</div>
			<div className="mt-2 flex justify-center">
				<div className="max-w-[516px] text-center text-base font-normal dark:text-[#C7C9D9] text-[#555770]">
				  Check out new courses and get started on your career journey.
				</div>
			</div>
			<div className="mt-6 flex justify-center">
				<Button
					color="purplePlaced"
					onClick={() => {
						window.open('https://www.masaischool.com?utm_source=leveluphome&utm_medium=website&utm_campaign=sendtowebsite', '_blank', 'noopener,noreferrer');
					}}
				>
					{/* <FiCalendar size={20} className="mr-2" /> */}
					Here's Our Courses
				</Button>
				{/* <Button
					color="purplePlaced"
					onClick={() => {
						// router(`/dashboard`);
						router(`/my-applications`);
					}}
				>
					<FiCalendar size={20} className="mr-2" />
					Ok, Got it!
				</Button> */}
			</div>
		</div>
	);
};

export default NoApplicationsContainer;
